import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IIdAckResponse } from '../ack-schema';
import { idAckResponseSchema } from '../ack-schema';

export async function removeCollectionCreditApi(
  collectionId: number,
  creditId: number,
): Promise<IValidatedResponse<IIdAckResponse>> {
  return deleteRequest<IIdAckResponse>({
    path: `/sys/collections/${collectionId}/credits/${creditId}/v1`,
    schema: idAckResponseSchema,
  });
}
